import { clsx } from 'clsx';
import {
  MainCategoryStoryblok,
  SubCategoryItemStoryblok,
} from 'storyblok-types';
import { CategoryItem } from '../CategoryItem';
import { WizardItem, WizardStepData } from '../data/types';
import styles from '../Wizard/styles.module.css';

export const getSliderSizes = (
  currentStep: number,
  divHeights: { first: number; second: number },
): { sliderHeight: number; sliderTop: string | number } => {
  const { first, second } = divHeights;
  const sliderHeight = currentStep === 2 ? second : first;

  let sliderTop: string | number;

  switch (currentStep) {
    case 1:
      sliderTop = 0;
      break;
    case 2:
      sliderTop = `-${first}px`;
      break;
    case 3:
      sliderTop = `-${first + second}px`;
      break;
    default:
      sliderTop = 0;
  }

  return { sliderHeight, sliderTop };
};

export const buildQueryParams = (
  wizardData: Record<number, WizardStepData>,
): string => {
  const queryParams = Object.values(wizardData)
    .map((step) => step.linkParams)
    .reduce((acc, params) => ({ ...acc, ...params }), {});

  return new URLSearchParams(queryParams).toString();
};

export const renderCategoryItems = (
  categories: MainCategoryStoryblok[] | SubCategoryItemStoryblok[],
  onClickHandler: ({
    subCategories,
    question,
    profileImage,
    linkParamValue,
    isLastStep,
  }: WizardItem) => void,
  isLastStep: boolean = false,
) => (
  <div
    className={clsx(styles.answerList, styles[`has${categories.length}Items`])}
  >
    {categories?.map(
      ({
        _uid,
        title,
        subCategoryQuestion,
        subCategories,
        image,
        profileImage,
        linkParamValue,
      }) => (
        <CategoryItem
          key={_uid}
          title={title}
          image={image?.filename}
          onClick={() =>
            onClickHandler({
              subCategories,
              question: subCategoryQuestion,
              profileImage: profileImage?.filename,
              linkParamValue,
              isLastStep,
            })
          }
        />
      ),
    )}
  </div>
);
